import { useEffect, useState } from 'react';
import { contactApi } from './api';
import './ContactsScreen.css';

function formatDate(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString(undefined, {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

export default function ContactsScreen({ onMessage }) {
  const flash = (t) => onMessage?.(t);
  const [contacts, setContacts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    contactApi
      .list()
      .then((res) => {
        const list = res.data.data || [];
        setContacts(list);
        setSelected(list[0] || null);
      })
      .catch(() => flash('Could not load messages'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="msg-screen">
      <aside className="msg-screen__list">
        <div className="msg-list-head">
          <p className="msg-screen__label">Inbox</p>
          <span>{contacts.length}</span>
        </div>
        {loading && <p className="msg-empty">Loading…</p>}
        {!loading && contacts.length === 0 && (
          <p className="msg-empty">No messages yet. Contact form submissions will appear here.</p>
        )}
        <div className="msg-items">
          {contacts.map((c) => (
            <button
              key={c._id}
              type="button"
              className={`msg-item${selected?._id === c._id ? ' is-active' : ''}`}
              onClick={() => setSelected(c)}
            >
              <strong>{c.name || 'Anonymous'}</strong>
              <span>{c.email}</span>
              <em>{formatDate(c.createdAt)}</em>
            </button>
          ))}
        </div>
      </aside>

      <section className="msg-screen__detail">
        {!selected ? (
          <div className="msg-detail-empty">
            <p>Select a message to read it.</p>
          </div>
        ) : (
          <>
            <header className="msg-detail__head">
              <div>
                <p className="msg-screen__label">From</p>
                <h2>{selected.name}</h2>
                <a href={`mailto:${selected.email}`}>{selected.email}</a>
              </div>
              <time>{formatDate(selected.createdAt)}</time>
            </header>
            {(selected.phone || selected.subject) && (
              <div className="msg-detail__meta">
                {selected.phone && <span>Phone · {selected.phone}</span>}
                {selected.subject && <span>Subject · {selected.subject}</span>}
              </div>
            )}
            <div className="msg-detail__body">
              <p>{selected.message}</p>
            </div>
          </>
        )}
      </section>
    </div>
  );
}
